import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TeachAppAndLandingColorPalette as Color } from '@lalalilo/enums';
import styled from 'styled-components';
import cookies from '../assets/cookies-1.svg';
import { Actions, BoxContent, BoxIllustration, BoxPresentation, BoxTitle, Button, } from './common';
export const OnlyNecessaryCookies = ({ onAccept, localizedStrings, }) => {
    const { preTitle, title, description, acknowledge } = localizedStrings;
    return (_jsxs(_Fragment, { children: [_jsxs(BoxContent, { children: [_jsx(BoxIllustration, { src: cookies }), _jsx(PreTitle, { children: preTitle }), _jsx(Title, { children: title }), _jsx(BoxPresentation, { children: description })] }), _jsx(Actions, { children: _jsx(Button, Object.assign({ onClick: onAccept, color: Color.purple_600, "data-test": "acknowledge-cookies" }, { children: acknowledge })) })] }));
};
const PreTitle = styled.div `
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 3px;
  font-weight: bold;
  color: ${Color.grey_600};
  text-align: center;
`;
const Title = styled(BoxTitle) `
  margin-top: 0px;
  margin-bottom: 18px;
`;
//# sourceMappingURL=OnlyNecessaryCookies.js.map